import React from "react";
import { Drawer, Form, DatePicker, Input, Button } from "antd";
import locale from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";
import { EditForm } from "../types";

const KidsWorldFormDrawer: React.FC<{
  open: boolean;
  loading: boolean;
  initial?: Partial<EditForm>;
  onClose: () => void;
  onSubmit: (v: EditForm) => void;
}> = ({ open, loading, initial, onClose, onSubmit }) => {
  const [form] = Form.useForm<EditForm>();
  const wasOpenRef = React.useRef(false);

  React.useEffect(() => {
    if (open && !wasOpenRef.current) {
      form.resetFields();
      if (initial) form.setFieldsValue(initial);
    }
    wasOpenRef.current = open;
  }, [open]);

  const submit = async () => {
    const v = await form.validateFields();
    onSubmit(v);
  };

  const monthVal = Form.useWatch("month", form);
  const v1Val = Form.useWatch("v1", form);
  const disabled = !monthVal || !(v1Val && String(v1Val).trim().length > 0);

  const disabledDate = (d?: dayjs.Dayjs) =>
    !!d && d.startOf("month").isBefore(dayjs().startOf("month"));

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="right"
      width={440}
      title="Manage latest Kid's World videos"
      destroyOnClose
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, padding: "8px" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={submit} disabled={disabled} loading={loading}>
            Submit
          </Button>
        </div>
      }
    >
      <Form<EditForm> form={form} layout="vertical">
        <Form.Item
          label="Year month"
          name="month"
          rules={[
            { required: true, message: "Please select month" },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                return value.startOf("month").isBefore(dayjs().startOf("month"))
                  ? Promise.reject(new Error("Only current or future months are allowed"))
                  : Promise.resolve();
              },
            },
          ]}
        >
          <DatePicker
            picker="month"
            locale={locale}
            style={{ width: "100%" }}
            format="YYYY-MMM"
            placeholder="Select month"
            disabledDate={disabledDate}
          />
        </Form.Item>
        <div className="kw-drawer-separator">
          <span>Enter Vimeo video ID below</span>
        </div>
        <Form.Item label="Video 1" name="v1" rules={[{ required: true, message: "Please enter Vimeo ID" }]}>
          <Input placeholder="Vimeo ID" />
        </Form.Item>
        <Form.Item label="Video 2" name="v2">
          <Input placeholder="Vimeo ID" />
        </Form.Item>
        <Form.Item label="Video 3" name="v3">
          <Input placeholder="Vimeo ID" />
        </Form.Item>
        <Form.Item label="Video 4" name="v4">
          <Input placeholder="Vimeo ID" />
        </Form.Item>
        <Form.Item label="Video 5" name="v5">
          <Input placeholder="Vimeo ID" />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default KidsWorldFormDrawer;
